import { SerializedError } from '@reduxjs/toolkit'

import { Bank } from '../../../client/Interfaces/Banking'
import { PeriodPickerValue } from '../../components/common/PeriodPicker/PeriodPicker'

export interface TransactionAmount {
  currency: string
  amount: number
}

export interface InvoiceInfo {
  invoiceNumber: string
  id: number
}

export interface UserInfo {
  name: string
}

export interface BankTransaction {
  id: string
  bankId: string
  accountId: string
  senderNameAddress: string
  referenceNumber?: string
  transactionAmount: TransactionAmount
  transactionDate: string
  bookingDate: string
  creditor?: UserInfo
  debtor?: UserInfo
  additionalInfo?: string
  creditDebitIndicator: string
  invoices?: InvoiceInfo[]
  potentialInvoices?: string[]
  mappingDate?: string
  unmappingDate?: string
  mappingType?: string
  status: string
  excluded: boolean
}

enum Status {
  ACTIVE = 'active',
  DISCONNECTED = 'disconnected',
  EXPIRED = 'expired',
  INCOMPLETE = 'incomplete',
  NOCONNECTIONS = 'noConnections',
}

interface BankTransactionSummary {
  company: number
  showBankingPopup: boolean
  status: Status
  banks?: Bank[]
}

export enum SelectionInterval {
  TenDays = 10,
  ThirtyDays = 30,
  SixtyDays = 60,
  SixMonths = -1,
}

interface BankSettings {
  transactionsFilterPeriod?: SelectionInterval
}

export type BankTransactionsStatus = 'idle' | 'loading' | 'succeed' | 'failed' | 'expired'

export interface BankTransactionsState {
  bankTransactions: BankTransaction[]
  selectedDatePeriod: PeriodPickerValue
  currentMatchStatus: string
  status: BankTransactionsStatus
  error: SerializedError
  bankTransactionSummary: BankTransactionSummary
  settings?: BankSettings
}
